import React from 'react';
import * as Styled from './MapContainerStyles';
import {
  MapContainerPropsInterface,
  MarkerInterface,
} from './MapContainerType';
import MonitoringMap from './MonitoringMap';
import { validLocation } from './MonitoringMapContants';

function MonitoringMapContainer({ data, width }: MapContainerPropsInterface) {
  function getPropsMap(): MarkerInterface | null {
    if (!data) return null;

    const { journey } = data;

    const origin = journey?.address.pickup.location;
    const destination = journey?.address.delivery.location;
    const lastLocation = journey?.trucker.lastLocation.coordinates;

    const isValid =
      validLocation(origin) ||
      validLocation(destination) ||
      validLocation(lastLocation);

    const marker = isValid ? journey : null;

    if (marker) {
      return {
        origin: {
          lat: origin.lat,
          lon: origin.lon,
        },
        destination: {
          lat: destination.lat,
          lon: destination.lon,
        },
        lastLocation: {
          lat: lastLocation.lat,
          lon: lastLocation.lon,
        },
        occurrencesLocation: marker.occurrences,
        journeyId: marker.id,
      };
    }

    return null;
  }

  return (
    <Styled.ContainerMap height={288} width={width || 200}>
      <MonitoringMap
        markers={getPropsMap()}
        width={width || 200}
        height={288}
      />
    </Styled.ContainerMap>
  );
}
export default MonitoringMapContainer;
